var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExecutiveProfilesIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.33317 12.25V11.0833C9.33317 10.4645 9.08734 9.871 8.64975 9.43342C8.21217 8.99583 7.61868 8.75 6.99984 8.75H3.49984C2.881 8.75 2.28751 8.99583 1.84992 9.43342C1.41234 9.871 1.1665 10.4645 1.1665 11.0833V12.25",
    stroke: "#E7000B",
    strokeWidth: 1.16667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.24984 6.41667C6.5385 6.41667 7.58317 5.372 7.58317 4.08333C7.58317 2.79467 6.5385 1.75 5.24984 1.75C3.96117 1.75 2.9165 2.79467 2.9165 4.08333C2.9165 5.372 3.96117 6.41667 5.24984 6.41667Z",
    stroke: "#E7000B",
    strokeWidth: 1.16667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8335 12.2501V11.0834C12.8331 10.5664 12.661 10.0642 12.3443 9.65561C12.0275 9.24701 11.5841 8.95518 11.0835 8.82593",
    stroke: "#E7000B",
    strokeWidth: 1.16667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.3335 1.82593C9.8354 1.95444 10.2803 2.24634 10.598 2.65561C10.9156 3.06488 11.0881 3.56824 11.0881 4.08634C11.0881 4.60444 10.9156 5.10781 10.598 5.51708C10.2803 5.92635 9.8354 6.21825 9.3335 6.34676",
    stroke: "#E7000B",
    strokeWidth: 1.16667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExecutiveProfilesIcon);
export default __webpack_public_path__ + "static/media/ExecutiveProfilesIcon.bb38cec9248397cf96bde5d079614dbf.svg";
export { ForwardRef as ReactComponent };